const baseUrlPrefix = process.env.NEXT_PUBLIC_BASE_PATH;

export function getBaseUrl() {
  if (typeof window !== "undefined") {
    if (window.location.hostname.startsWith("http://192.168")) {
      return window.location.origin;
    }

    return baseUrlPrefix;
  }

  if (process.env.NEXT_PUBLIC_DOMAIN) {
    return `https://${process.env.NEXT_PUBLIC_DOMAIN}${baseUrlPrefix}`;
  }

  return `http://localhost:${process.env.PORT ?? 3000}${baseUrlPrefix}`;
}

export function getAbsoluteBaseUrl() {
  if (typeof window !== "undefined") {
    if (window.location.hostname.startsWith("http://192.168")) {
      return window.location.origin;
    }
  }

  if (process.env.NEXT_PUBLIC_DOMAIN) {
    return `https://${process.env.NEXT_PUBLIC_DOMAIN}${baseUrlPrefix}`;
  }

  return `http://localhost:${process.env.PORT ?? 3000}${baseUrlPrefix}`;
}

export function getDevelopmentProxyApiUrl() {
  const basePath = process.env.NEXT_PUBLIC_BASE_PATH ?? "";

  if (typeof window !== "undefined") {
    return `${window.location.origin}${basePath}`;
  }

  return `http://localhost:${process.env.PORT ?? 3000}${basePath}`;
}

const pbPath = process.env.NEXT_PUBLIC_PB_PATH ?? "";

export function getPbApiUrl() {
  return `${process.env.NEXT_PUBLIC_API_URL ?? "http://localhost:8000"}${pbPath}`;
}

export function getPbCdnUrl() {
  return `${process.env.NEXT_PUBLIC_CDN_URL ?? ""}${pbPath}`;
}

export function getApiUrl(version = "v1") {
  return `${getPbApiUrl()}/api/${version}`;
}
